import LoadbarComponent from "slotworks/components/preloader/loadbar-component";
import PromptContent, { LoadType } from "slotworks/components/prompt/prompt-content";
import Layers from "slotworks/graphics/layers/layers";
import Loader from "slotworks/loader/loader";
import SettingsModel from "slotworks/model/settings/settings-model";
import Contract from "slotworks/utils/contract";

export default class RSPromptComponent {

    public static DEFAULT_TIME = 5000;

    private currentPrompt: PromptContent;

    public showPrompt(prompt: PromptContent, loadStage: number = null, continueFunction: Function = null): Contract<void> {

        this.currentPrompt = prompt;

        return new Contract<void>((resolve) => {

            this.currentPrompt.show().then(() => {
                let raceStages = 1;

                const raceHandler = () => {
                    raceStages--;
                    if (raceStages === 0) {
                        if(continueFunction) continueFunction();
                        this.currentPrompt.hide().then(() => resolve(null)).execute();
                    }
                };

                this.currentPrompt.enableContinueButton();

                if (loadStage) {
                    raceStages++;
                    if (this.currentPrompt.getLoadRaceType() === LoadType.DISABLE_BUTTON) {
                        this.currentPrompt.disableContinueButton();
                    } else if (this.currentPrompt.getLoadRaceType() === LoadType.HIDE_BUTTON) {
                        this.currentPrompt.hideContinueButton();
                    }

                    this.loadStage(loadStage).then(() => {
                        this.currentPrompt.enableContinueButton();
                        raceHandler();
                    });
                }

                const onKeyUp = (event: any) => {             
                    if (SettingsModel.getSpaceToSpin()) {
                        if (event.keyCode === 32) {
                            onContinue();
                        }
                    }
                };

                const onContinue = () => {
                    document.removeEventListener("keyup", onKeyUp);

                    if (this.currentPrompt.getLoadRaceType() === LoadType.LOADING_SCENE && Layers.Prompts.hasScene("loading")) {
                        Layers.Prompts.setScene("loading").then(() => raceHandler());
                    } else {
                        raceHandler();
                    }
                };

                document.addEventListener("keyup", onKeyUp);
                this.currentPrompt.addContinueListener(() => {
                    onContinue();
                });
            });
        });
    }

    public hide() {
        this.currentPrompt.hide().execute();
    }

    private loadStage(stageId: number): Contract<void> {

        const bar = Layers.Prompts.getSprite("loadbar");

        const loadBar = new LoadbarComponent(bar, Loader.getStageFiles(stageId));

        let loadSprite: PIXI.DisplayObject = Layers.Prompts.getSprite("loading_sprite");
        if (!loadSprite) {
            const loadButton = Layers.Prompts.getButton("loading_sprite");
            if (loadButton) {
                loadSprite = loadButton.container;
            }
        }

        loadBar.addLoadingText(Layers.Prompts.getText("loading_label"), Layers.Prompts.getText("loading_percentage"), loadSprite);

        return new Contract<void>((resolve) => {
            Loader.loadStage(stageId, (stage: number, progress: number, resource: PIXI.LoaderResource) => {
                loadBar.fileLoaded(resource);
            }).then(() => loadBar.loadComplete().then(() => resolve(null)));
        });
    }
}




// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/components/prompt/prompt-component.ts